import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';

const S = {
  page: {
    minHeight: '100vh', background: '#1B2A4A', display: 'flex',
    alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: '#fff', borderRadius: 12, padding: '40px 36px',
    width: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    borderTop: '4px solid #C9A84C',
  },
  logoWrap: { textAlign: 'center', marginBottom: 28 },
  mark: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 48, height: 48, background: '#2563EB', borderRadius: 10,
    color: '#fff', fontWeight: 700, fontSize: 18, marginBottom: 10,
  },
  title:    { fontSize: 22, fontWeight: 700, color: '#1B2A4A', margin: '0 0 2px' },
  subtitle: { fontSize: 12, color: '#94A3B8', margin: 0 },
  label:    { display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 },
  input: {
    width: '100%', padding: '10px 12px', borderRadius: 7, border: '1px solid #D1D5DB',
    fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 16,
  },
  btn: {
    width: '100%', padding: '11px', background: '#2563EB', color: '#fff',
    border: 'none', borderRadius: 7, fontSize: 14, fontWeight: 600,
    cursor: 'pointer', marginTop: 4,
  },
  err: {
    background: '#FEE2E2', color: '#B91C1C', padding: '10px 12px',
    borderRadius: 7, fontSize: 13, marginBottom: 14,
  },
  hint: { fontSize: 11, color: '#94A3B8', textAlign: 'center', marginTop: 16 },
};

export default function Login({ setIsAuth, setUser }) {
  // const [email, setEmail]     = useState('admin@monitor.ci');
  // const [password, setPassword] = useState('Monitor2025');

  // Vider les credentials hardcodés
const [email, setEmail]       = useState('');
const [password, setPassword] = useState('');

  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const navigate              = useNavigate();

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   setError('');
  //   setLoading(true);
  //   try {
  //     console.log(email, password);
      
  //     const { data } = await login(email, password);
  //     localStorage.setItem('monitor_token', data.token);
  //     localStorage.setItem('monitor_user',  JSON.stringify(data.user));
  //      setIsAuth(true);
  //     navigate('/dashboard');
  //   } catch (err) {
  //     setError(err.response?.data?.error || 'Connexion impossible — vérifiez vos identifiants');
  //   } finally {
  //     setLoading(false);
  //   }
  // }
// Dans handleSubmit, mettre à jour aussi le state user dans App
async function handleSubmit(e) {
  e.preventDefault();
  setError('');
  setLoading(true);
  try {
    const { data } = await login(email, password);
    localStorage.setItem('monitor_token', data.token);
    localStorage.setItem('monitor_user', JSON.stringify(data.user));
    setUser(data.user);   // ← nouveau
    setIsAuth(true);
    navigate('/dashboard');
  } catch (err) {
    setError(err.response?.data?.error || 'Connexion impossible — vérifiez vos identifiants');
  } finally {
    setLoading(false);
  }
}
  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logoWrap}>
          <div style={S.mark}>RI</div>
          <h1 style={S.title}>MONITOR</h1>
          <p style={S.subtitle}>Supervision Platform — RevealIT</p>
        </div>

        {error && <div style={S.err}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={S.label}>Adresse email</label>
          <input
            style={S.input} type="email" required
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
          <label style={S.label}>Mot de passe</label>
          <input
            style={S.input} type="password" required
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
          <button style={S.btn} type="submit" disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <p style={S.hint}>Identifiants par défaut : admin@monitor.ci / Monitor2025</p>
      </div>
    </div>
  );
}
